import React, { useEffect, useState } from 'react';
import './App.css';
import Login from './components/Login';
import { getTokenFromUrl } from './spotify';
import SpotifyWebApi from "spotify-web-api-js";
import Player from './components/Player';
import { useDataLayerValue } from './DataLayer';

const spotify = new SpotifyWebApi()

function App() {
  const [token, setToken] = useState(null);
  const [DataLayer, dispatch] = useDataLayerValue();

  useEffect(() => {
    const hash = getTokenFromUrl();
    window.location.hash = "";
    const _token = hash.access_token;

    if (_token) {
      dispatch({
        type: "SET_TOKEN",
        token: _token,
      })
      setToken(_token)
      spotify.setAccessToken(_token)
      spotify.getMe().then(user => {
        console.log(user);

        dispatch({
          type: 'SET_USER',
          user: user
        })
      });

    }
    spotify.getUserPlaylists().then((playlist) => {
      dispatch({
        type: "SET_PLAYLISTS",
        playlists: playlist,
      });
      console.log(playlist);
    })


    spotify.getPlaylist("734GJG9BpowDnq77Ux2nhC").then(response => {

      dispatch({
        type: "SET_DISCOVER_WEEKLY",
        discover_weekly: response,
      })
    })

  }, [dispatch]);

  // console.log("DATALAYER", DataLayer.user);
  //console.log("DATALAYER", DataLayer.token);

  return (
    <div className="app">
      {/* logo*/}
      {/* login */}
      {
        token ? <Player spotify={spotify} /> : <Login />
      }

    </div>
  );
}

export default App;
